{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chưa cài đặt tiện ích mở rộng Chrome.",
      "CTA": "Cài đặt tiện ích mở rộng"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Không thể kết nối với hệ thống điện thoại",
      "MESSAGE": "Kết nối internet của bạn có vẻ đã bị gián đoạn. Vui lòng kiểm tra và thử lại.",
      "CREDENTIALS_TITLE": "Hệ thống điện thoại đã từ chối thông tin đăng nhập của bạn",
      "CREDENTIALS_MESSAGE": "Hệ thống điện thoại đã từ chối tên người dùng hoặc mật khẩu được lưu trong hồ sơ của bạn. Vui lòng kiểm tra trong Cài Đặt Hồ Sơ, hoặc liên hệ quản trị viên của bạn.",
      "CONFIGURATION_TITLE": "Cài đặt điện thoại không hợp lệ",
      "CONFIGURATION_MESSAGE": "Tên người dùng SIP hoặc địa chỉ máy chủ không đúng định dạng, nên điện thoại không thể kết nối. Vui lòng sửa trong Cài Đặt Hồ Sơ.",
      "NETWORK_SHORT": "Kết nối thất bại",
      "CREDENTIALS_SHORT": "Thông tin đăng nhập bị từ chối",
      "CONFIGURATION_SHORT": "Cài đặt điện thoại không hợp lệ",
      "RETRY": "Thử lại",
      "DISMISS": "Huỷ"
    },
    "CONNECTION_QUALITY": "Chất lượng kết nối",
    "CONNECTION_QUALITY_EXCELLENT": "Xuất sắc",
    "CONNECTION_QUALITY_GOOD": "Tốt",
    "CONNECTION_QUALITY_FAIR": "Khá",
    "CONNECTION_QUALITY_POOR": "Kém",
    "CONNECTION_QUALITY_DISCONNECTED": "Đã ngắt kết nối",
    "TABS": {
      "PHONE": "Điện thoại",
      "SMS": "SMS",
      "HISTORY": "Lịch sử"
    },
    "HISTORY": {
      "OPEN": "Mở",
      "RECENT": "Gần đây",
      "MISSED": "Nhỡ",
      "LOADING": "Đang tải cuộc gọi...",
      "EMPTY": "Không có cuộc gọi nào",
      "ERROR": "Không thể tải cuộc gọi",
      "CALL": "Gọi lại",
      "CALL_STATUS": {
        "BUTTON": "Đặt trạng thái cuộc gọi",
        "TITLE": "Trạng thái cuộc gọi",
        "SEARCH_PLACEHOLDER": "Tìm kiếm trạng thái...",
        "LOADING": "Đang tải trạng thái...",
        "NO_OPTIONS": "Chưa cấu hình trạng thái cuộc gọi nào.",
        "NO_MATCH": "Không có trạng thái nào khớp",
        "OPTIONS_ERROR": "Không thể tải trạng thái",
        "RETRY": "Thử lại",
        "CONFIRM_QUESTION": "Đặt '{status}' và giải quyết hội thoại này?",
        "CONFIRM": "Xác nhận",
        "BACK": "Trở về",
        "CANCEL": "Huỷ",
        "SAVING": "Đang lưu...",
        "SAVE_ERROR": "Không thể lưu trạng thái",
        "RESOLVE_ERROR": "Đã lưu trạng thái, nhưng không thể giải quyết hội thoại này."
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Số điện thoại, ví dụ +421903000000",
      "BODY_PLACEHOLDER": "Nhập tin nhắn của bạn...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Gửi SMS",
      "SENDING": "Đang gửi...",
      "SENT": "Đã gửi SMS",
      "LOADING": "Đang tải hộp thư đến SMS...",
      "NO_INBOX": "Tài khoản này không có hộp thư đến SMS nên không thể gửi SMS.",
      "INVALID_NUMBER": "Nhập số theo định dạng quốc tế, bao gồm dấu + ở đầu.",
      "ERROR": "Không thể gửi SMS. Vui lòng thử lại."
    },
    "ACTIONS": {
      "CONNECT": "Kết nối",
      "GO_TO_TAB": "Đi đến tab đó",
      "DISCONNECT": "Ngắt kết nối",
      "ANSWER": "Trả lời",
      "HANGUP": "Cúp máy",
      "HOLD": "Giữ máy",
      "MUTE": "Tắt micrô",
      "SILENCE": "Tắt âm thanh",
      "TRANSFER": "Chuyển cuộc gọi",
      "COMPLETE_TRANSFER": "Hoàn tất chuyển cuộc gọi",
      "RETURN_TO_CALLER": "Quay lại người gọi",
      "CANCEL_TRANSFER": "Huỷ chuyển cuộc gọi",
      "DIALPAD": "Hiện bàn phím quay số",
      "OPEN_CONVERSATION": "Mở hội thoại"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Cuộc gọi đến",
      "INCOMING_CALL_FROM": "Cuộc gọi đến từ {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Cuộc gọi đến từ {number}",
      "ANSWER": "Trả lời",
      "DECLINE": "Từ chối"
    },
    "TRANSFER": {
      "TITLE": "Chuyển cuộc gọi",
      "PLACEHOLDER": "Nhập số điện thoại cần chuyển đến...",
      "SEARCH_PLACEHOLDER": "Tìm kiếm nhân viên...",
      "TARGET_PLACEHOLDER": "Đích chuyển đã chọn",
      "CONFIRM": "Chuyển cuộc gọi",
      "MODE_DIRECT": "Chuyển ngay",
      "MODE_CONSULT": "Gọi cho nhân viên trước",
      "CANCEL": "Huỷ"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Bạn có chắc muốn nghỉ giải lao cho tất cả hàng đợi không?",
      "CONFIRM_READY": "Bạn có chắc muốn quay lại trạng thái sẵn sàng cho tất cả hàng đợi không?",
      "CONFIRM_BREAK_QUEUE": "Bạn có chắc muốn đăng xuất khỏi hàng đợi {queue} không?",
      "CONFIRM_READY_QUEUE": "Bạn có chắc muốn đăng nhập vào hàng đợi {queue} không?",
      "LOGIN_TO_QUEUE": "Đăng nhập",
      "LOGOUT_FROM_QUEUE": "Đăng xuất",
      "LOGIN_TO_ALL_QUEUES": "Đăng nhập vào tất cả hàng đợi",
      "LOGOUT_FROM_ALL_QUEUES": "Đăng xuất khỏi tất cả hàng đợi",
      "OPTION_LOGOUT": "Đăng xuất",
      "OPTION_BREAK": "Nghỉ giải lao",
      "OPTION_LUNCH": "Nghỉ trưa",
      "OPTION_AWAY": "Vắng mặt",
      "OPTION_DO_NOT_DISTURB": "Không làm phiền",
      "OPTION_BUSINESS_TRIP": "Công tác",
      "CONFIRM": "Xác nhận",
      "CANCEL": "Huỷ"
    },
    "STATUS": {
      "OFFLINE": "Điện thoại ngoại tuyến",
      "IN_OTHER_TAB": "Điện thoại đang kết nối ở một tab khác",
      "CONNECTING": "Đang kết nối...",
      "DISCONNECTING": "Đang ngắt kết nối...",
      "ONLINE": "Điện thoại trực tuyến",
      "DIALING": "Đang gọi",
      "TRANSFERRING": "Đang chuyển cuộc gọi...",
      "CONSULTING": "Đang nói chuyện với nhân viên",
      "CALLER_ON_HOLD": "Người gọi đang chờ",
      "BUSY": "Bận",
      "DND": "DND",
      "UNAVAILABLE": "Không khả dụng",
      "REJECTED": "Cuộc gọi bị từ chối",
      "CALL_FAILED": "Cuộc gọi thất bại"
    },
    "QUEUES": {
      "MORE": "Hàng đợi khác"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Đang gọi {number}… Bạn có thể đóng tab này.",
    "NO_NUMBER": "Chưa cung cấp số điện thoại. Hãy dùng ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Nhập số điện thoại...",
    "ACTIONS": {
      "DIAL": "Gọi số",
      "DIAL_FROM": "Chọn số để gọi đi"
    },
    "DIAL_FROM": {
      "TITLE": "Gọi từ số của hộp thư"
    },
    "VALIDATION": {
      "REQUIRED": "Cần nhập số điện thoại",
      "INVALID_FORMAT": "Định dạng số điện thoại không hợp lệ"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Cài đặt & kiểm tra âm thanh",
    "SELECT_DEVICE": "Chọn thiết bị...",
    "SYSTEM_DEFAULT": "Mặc định hệ thống",
    "SAVED": "Đã lưu",
    "DISCONNECTED_SUFFIX": "chưa kết nối",
    "DEVICE_DISCONNECTED": "Thiết bị đã chọn hiện chưa được kết nối. Cuộc gọi sẽ dùng mặc định hệ thống cho đến khi thiết bị kết nối trở lại.",
    "MICROPHONE": {
      "TITLE": "Micrô",
      "START_TEST": "Kiểm tra micrô",
      "STOP_TEST": "Dừng kiểm tra",
      "LEVEL": "Mức:",
      "VERDICT": {
        "LISTENING": "Hãy nói gì đó vào micrô…",
        "SILENT": "Không thể nghe thấy giọng bạn. Hãy kiểm tra micrô đã bật và đã chọn đúng micrô.",
        "LOW": "Giọng bạn nghe rất nhỏ. Hãy chọn micrô khác hoặc điều chỉnh âm lượng đầu vào trong cài đặt hệ thống.",
        "GOOD": "Âm thanh tốt — giọng bạn nghe rõ."
      }
    },
    "SPEAKER": {
      "TITLE": "Loa",
      "TEST": "Kiểm tra loa",
      "TESTING": "Đang kiểm tra...",
      "VOLUME": "Âm lượng:",
      "USING_DEFAULT": "Thiết bị đầu ra đã chọn không khả dụng — đã phát qua thiết bị mặc định của hệ thống."
    },
    "DONE": "Xong",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Lỗi khi truy cập micrô. Vui lòng kiểm tra quyền truy cập.",
      "MICROPHONE_PERMISSION_DENIED": "Quyền truy cập micrô đang bị chặn. Hãy cho phép trong cài đặt trang web của trình duyệt để sử dụng điện thoại.",
      "MICROPHONE_SILENT": "Micrô của bạn không thu được âm thanh nào. Hãy kiểm tra cài đặt âm thanh của bạn.",
      "EXTENSION_REQUIRED": "Không phát hiện tiện ích mở rộng điện thoại. Vui lòng cài đặt hoặc bật tiện ích này để sử dụng micrô.",
      "SPEAKER_TEST": "Lỗi khi kiểm tra đầu ra của loa."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Ngoại tuyến",
    "ONLINE": "Trực tuyến",
    "BUSY": "Bận"
  },
  "QUEUE_STATUS": {
    "READY": "Sẵn sàng",
    "NOT_READY": "Không nhận cuộc gọi",
    "WRAP_UP": "Xử lý sau cuộc gọi",
    "BREAK": "Nghỉ giải lao",
    "LUNCH": "Nghỉ trưa",
    "AWAY": "Vắng mặt",
    "DO_NOT_DISTURB": "Không làm phiền",
    "BUSINESS_TRIP": "Công tác",
    "OTHER_CALL": "Cuộc gọi khác",
    "QUEUE_CALL": "Cuộc gọi hàng đợi",
    "OFFLINE": "Ngoại tuyến",
    "ONLINE": "Trực tuyến",
    "NO_ACCESS": "Không có điện thoại",
    "PARTIALLY_READY": "Sẵn sàng một phần",
    "MIXED": "Hỗn hợp",
    "CHAT_ONLINE": "Trực tuyến (chat)",
    "CHAT_BUSY": "Bận (chat)",
    "CHAT_OFFLINE": "Ngoại tuyến (chat)"
  }
}
